import { createEntityAdapter } from '@reduxjs/toolkit'

import { Group } from './models/Group'

export const groupsAdapter = createEntityAdapter({
  selectId: (group: Group) => group.id,
})
